export default "__VITE_ASSET__BSJY0Dhi__"